import { render, staticRenderFns } from "./CurrentAvatar.vue?vue&type=template&id=84f9f934&lang=pug&"
import script from "./CurrentAvatar.vue?vue&type=script&lang=js&"
export * from "./CurrentAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports